import React from "react";
import NavbarContainer from "../../../Navbar/NavbarContainer";
import "./SMRDashboardPage.scss";
import { Link } from "react-router-dom";
import UseGAEventsTracker from "../../../hooks/UseGAEventsTracker";

const SMRDashboardPage = (props) => {
    const GAEventsTracker = UseGAEventsTracker("SMR Dashboard");

    const IndividualDashboard = (dashboard) => {
        return (
            <div className="dasboard-list-item">
                <div className="dashboard-thumbnail">
                    <img src={"https://radarr.s3.ap-southeast-1.amazonaws.com/dashboard-thumbnails/basic_dashboard.svg"} alt="dashbaord-thumbnail" />
                </div>
                <div className="dashboard-name" key={dashboard.id}>
                    <p title={dashboard.name}>{dashboard.name}</p>
                </div>
            </div>
        );
    };
    const handleClick = (dashboard) => {
        GAEventsTracker("Dashboard clicked", dashboard.name);
    };

    return (
        <>
            <div className={`smr-dashboard-container `}>
                <NavbarContainer history={props.history} location={props.location} pageTitle="Social Media Response" />
                <div className="dashboard-types">
                    <div className="dashboard">
                        <p className="dashboard-title">SMR Dashboards</p>
                        <div className="dashboard-list">
                            {smrDashboardLists.map((d) => (
                                <Link key={d.id} to={d.link} onClick={() => handleClick(d)}>
                                    {IndividualDashboard(d)}
                                </Link>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SMRDashboardPage;
export const smrDashboardLists = [
    {
        id: 1,
        name: "SLA Dashboard",
        link: "dashboard/sla",
    },
    {
        id: 2,
        name: "Team Overview Dashboard",
        link: "dashboard/team-overview",
    },
    {
        id: 3,
        name: "CSAT Dashboard",
        link: "dashboard/csat",
    },
    {
        id: 4,
        name: "Ticket Analysis Dashboard",
        link: "dashboard/ticket-analysis",
    },
];
